// reducer.js
import { SET_FINAL_ASSET_ANALYSIS_JSON } from '../actions/assetActions';

const initialState = {
  sections: [
    { title: 'Asset Details', data: [
      ["Rental Status", ""],
      ["T&C No.", ""],
      ["T&C Old No.", ""],
      ["Old Asset No", ""],
      ["Asset Classification",""],
      ["Finance Asset No.",""],
      ["Asset Description", ""],
      ["Type Description", ""],
      ["Type Code",""],
      ["Location No",""],
      ["Location Name",""],
      ["User Department",""],
      ["Department Description",""],
      ["Criticality",""],
      ["Work Group",""],
      ["PPM Required",""],
      ["PPM Status",""],
      ["Parent Asset No",""],
      ["Description",""],
      ["Reason",""],
    ]},
     { title: 'Asset Specification', data: [
    ["Make",""],
    ["Brand",""],
    ["Model",""],
    ["Serial No",""],
    ["Capacity",""],
    ["Asset status",""],
    ["Life Span(yrs)",""],
    ["Manufacture",""],
    ]},
     { title: 'Purchase Details', data: [
      ["Purchase Order No",""],
      ["Purchase Cost in RM",""],
      ["Purchase Flag",""],
      ["Warranty Start Date",""],
      ["Warranty End Date",""],
      ["Commissioning Date",""],
      ["Accessories",""],
      ["Under waranty",""],
      ["Cumulative Part Cost in (RM)",""],
      ["Last Scheduled Work Order",""],
      ["Last Unscheduled Work Order",""],
      ["Depreciation value/Year in RM",""],
      ["Asset Transfer Category",""],
    ]},
    { title: 'Maintenance History', data: [
      ["WO No",""],
      ["Wo Date",""],
      ["Wo Type",""]
    ]},
 
  ],
};

const assetAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FINAL_ASSET_ANALYSIS_JSON:
      return {
        ...state,
        sections: action.payload,
      };
    default:
      return state;
  }
};

export default assetAnalysisReducer;
